export enum BreadcrumbsColor {
  Light = "light",
  Dark = "dark",
  Neutral = "neutral",
  Primary = "primary",
}

export enum BreadcrumbsVariant {
  Transparent = "transparent",
  Filled = "filled",
}

export enum BreadcrumbsPosition {
  Overlap = "overlap",
  Block = "block",
}
